import { Text } from '@truepill/react-capsule'
import { AlertOctagon } from 'react-feather'
import styled from 'styled-components'
import {
  capsuleDarkGreenColor,
  capsuleLightGreenColor,
  capsuleWarningDark,
  capsuleWarningLight,
} from 'styles/styleVariables'

type MedicalNoteAlertProps = {
  note: string
  variant?: 'warning' | 'success'
  disableBackgroundColor?: boolean
  style?: React.CSSProperties
}

export const MedicalNoteAlert = (props: MedicalNoteAlertProps): JSX.Element => {
  const { note, variant = 'warning', disableBackgroundColor, style } = props

  const backgroundColor = variant === 'success' ? capsuleLightGreenColor : capsuleWarningLight
  const textColor = variant === 'success' ? capsuleDarkGreenColor : capsuleWarningDark

  return (
    <MedicalNoteAlertContainer
      style={{
        backgroundColor: disableBackgroundColor ? 'inherit' : backgroundColor,
        ...style,
      }}
    >
      <IconWrapper>
        <AlertOctagon
          style={{
            color: textColor,
          }}
        />
      </IconWrapper>
      <TextWrapper>
        <Text
          css={{
            color: textColor,
          }}
        >
          {note}
        </Text>
      </TextWrapper>
    </MedicalNoteAlertContainer>
  )
}

const MedicalNoteAlertContainer = styled.div`
  border-radius: 0.5rem;
  padding: 0.6rem;
  gap: 0.6rem;
  display: flex;
  flex-direction: row;
`

const IconWrapper = styled.div`
  flex: 1;
  min-width: 1rem;
  min-height: 1rem;
`

const TextWrapper = styled.div`
  flex: 19;
`
